module.exports = __webpack_public_path__ + "VI.png?3d149d651fd8fa511fc6a6eb354acca9";